// @flow

import React from 'react';
import styled, { css } from 'styled-components';
import Text from './atoms/text';
import Link from './atoms/link';
import type { ReviewTemplate, ReviewView } from '../../types';
import type { Theme } from '../../../../types';

type Props = {|
  className?: string,
  basedOnText: string,
  url: string,
  linkText: string,
  template: ReviewTemplate,
|};

type StyleProps = {
  view: ReviewView,
  template: ReviewTemplate,
};

const ReviewLink = ({
  className = '',
  basedOnText,
  url,
  linkText,
  template,
}: Props) => (
  <section className={className}>
    <Text template={template}>
      {basedOnText}
    </Text>
    <Text template={template}>
      <Link
        useAnchor // When the site is released this prop should be removed (this forces a reload)
        template={template}
        className={className}
        href={url}
        caret
      >
        {linkText}
      </Link>
    </Text>
  </section>
);

ReviewLink.defaultProps = {
  className: '',
};

export default styled<typeof ReviewLink, Theme, StyleProps>(ReviewLink)`
  color: ${props => props.theme.review[props.template].reviewCountColor};
  font-size: ${props => props.theme.review.link.fontSize};
  line-height: 1.6;
  margin-top: .5rem;
  text-align: left;

  ${props => props.view === 'stacked' && css`
    text-align: center;
  `}
`;
